import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e3ce099e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ce099e')) {
      api.createRecord('e3ce099e', component.options)
    } else {
      api.reload('e3ce099e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e3ce099e", function () {
      api.rerender('e3ce099e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjLogButton/index.vue"
export default component.exports